import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FiArrowUpRight, FiCheckCircle } from "react-icons/fi";
import "./ServiceDetail.css";

function ServiceDetail({
  eyebrow,
  title,
  description,
  packages = [],
  process = [],
  ctaText = "Request a Quote",
  heroImage,
}) {
  const [selectedPackage, setSelectedPackage] = useState(null);
  const navigate = useNavigate();

  const handleContinue = () => {
    if (!selectedPackage) return;

    navigate("/checkout", {
      state: {
        plan: selectedPackage.name,
        price: selectedPackage.price,
        features: selectedPackage.features,
      },
    });
  };

  return (
    <section className="serviceDetailPage">
        <div
        className="serviceDetailHero"
        style={{ backgroundImage: `url(${heroImage})` }}
        >
        <span className="serviceDetailEyebrow">{eyebrow}</span>
        <h1>{title}</h1>
        <p>{description}</p>

        <a href="#packages" className="serviceDetailHeroBtn">
          View Packages
          <FiArrowUpRight />
        </a>
      </div>

      <div className="serviceDetailShell" id="packages">
        <header className="servicePackagesHead">
          <span className="serviceDetailEyebrow">Packages</span>
          <h2>{eyebrow} Packages</h2>
          <p>Choose the package that fits your goals. You can always upgrade later.</p>
        </header>

        <div className="servicePackageGrid">
          {packages.map((pkg) => {
            const selected = selectedPackage?.name === pkg.name;

            return (
              <article
                key={pkg.name}
                className={[
                  "servicePackageCard",
                  pkg.featured && "servicePackageCard--featured",
                  selected && "is-selected",
                ]
                  .filter(Boolean)
                  .join(" ")}
                onClick={() => setSelectedPackage(pkg)}
              >
                {pkg.featured && (
                  <span className="servicePackageBadge">Most Popular</span>
                )}

                <h3>{pkg.name}</h3>
                <p className="servicePackageSubtitle">{pkg.subtitle}</p>

                <p className="servicePackagePrice">
                  ${pkg.price.toLocaleString()}
                </p>

                <ul className="servicePackageFeatures">
                  {pkg.features.map((feature, index) => (
                    <li key={index}>
                      <FiCheckCircle />
                      {feature}
                    </li>
                  ))}
                </ul>

                <button
                  type="button"
                  className="servicePackageSelect"
                  onClick={(e) => {
                    e.stopPropagation();
                    setSelectedPackage(pkg);
                  }}
                >
                  {selected ? "Selected" : "Select Package"}
                </button>
              </article>
            );
          })}
        </div>

        <div className="servicePackagesAction">
          <button
            className={`servicePackagesCTA ${
              !selectedPackage ? "is-disabled" : ""
            }`}
            disabled={!selectedPackage}
            onClick={handleContinue}
          >
            {selectedPackage
              ? `Continue with ${selectedPackage.name}`
              : "Select a Package to Continue"}
          </button>
        </div>

        <div className="serviceDetailCard">
          <h2>How It Works</h2>

          <div className="serviceProcessGrid">
            {process.map((step, index) => (
              <div className="serviceProcessItem" key={index}>
                <strong>{String(index + 1).padStart(2, "0")}</strong>
                <h3>{step.title}</h3>
                <p>{step.text}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="serviceDetailCTA">
          <h2>Need something custom?</h2>
          <p>
            Let’s create a custom solution for your brand, budget, and goals.
          </p>

          <Link to="/#contact" className="serviceDetailHeroBtn">
            {ctaText}
            <FiArrowUpRight />
          </Link>
        </div>
      </div>
    </section>
  );
}

export default ServiceDetail;